// fetch wrapper — attaches Bearer token; surfaces typed JSON errors.

import { appConfig } from "@/env";

// appConfig returns undefined (never "") when unset, so `?? "/"` resolves.
const API_BASE_URL = appConfig("RAG_API_URL") ?? "/";

export interface ApiError {
  status: number;
  code?: string;
  detail?: string;
}

export interface RequestOpts {
  method?: "GET" | "POST" | "PATCH" | "DELETE";
  body?: unknown;
  signal?: AbortSignal;
}

export async function apiFetch<T = unknown>(path: string, token: string, opts: RequestOpts = {}): Promise<T> {
  const url = path.startsWith("http") ? path : `${API_BASE_URL.replace(/\/$/, "")}${path}`;
  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  };
  const init: RequestInit = { method: opts.method ?? "GET", headers, signal: opts.signal };
  if (opts.body !== undefined) {
    headers["Content-Type"] = "application/json";
    init.body = JSON.stringify(opts.body);
  }
  const res = await fetch(url, init);
  if (!res.ok) {
    let detail: string | undefined;
    let code: string | undefined;
    try {
      const body = await res.json();
      detail = typeof body?.detail === "string" ? body.detail : JSON.stringify(body);
      code = body?.code ?? body?.detail?.code;
    } catch {
      detail = res.statusText;
    }
    const err: ApiError = { status: res.status, code, detail };
    throw err;
  }
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}

export { API_BASE_URL };
